import { HistoryPagination, NotificationResult, GetAPi, MissingMessagesResult } from './iot-models'
import { IotMessageManager } from './iot-message-manager';
import { IotHistoryStorage } from './iot-history-storage.service';
export class IotHistoryManager {
    static $inject = [
        "errorsLogger",
        "restManager",
        "IotMessageManager",
        "IotHistoryStorage",
        "checkManager"
    ];

    constructor(
        private errorsLogger: any,
        private restManager: any,
        private iotMessageManager: IotMessageManager,
        private historyStorage: IotHistoryStorage,
        private checkManager: any
    ) {
    }

    /**
     * Logs an event using errorsLogger.sendReport
     * @param {*} message
     * @param content
     * @returns
     */
    private logMessagingEvent = (message: string, content: any, send_anyway: boolean) => {
        if (send_anyway == true) {
            this.errorsLogger.sendReport({
                type: 'iot-history: ' + message,
                content: content
            })
            return;
        }
        if (this.checkManager.getSetting("messaging.iot_send_report")) {
            this.errorsLogger.sendReport({
                type: 'iot-history: ' + message,
                content: content
            })
            return;
        }
    };

    private getList: GetAPi = async (entityName, entityID, queryString) => {
        let dataResponse = await this.restManager.getList(entityName, queryString);
        if (dataResponse.status) {
            throw dataResponse;
        } else {
            return dataResponse
        }
    }

    reset() {
        this.historyStorage.history.clear();
    }

    async processHistory(pagination: HistoryPagination): Promise<boolean> {
        try {
            if (pagination) {
                let resHistory: NotificationResult = await this.getList("notifications", undefined, pagination);
                if (resHistory.count > 0) {
                    // need to recover messages
                    for (let message of resHistory.items) {
                        await this.iotMessageManager.processMessage(message, true).catch(err => {
                            this.logMessagingEvent(`process message broken on: ${message.msg_id}`, err, true);
                        });
                    }
                }
                return true;
            } else {
                let resHistory: NotificationResult = await this.getList("notifications", undefined, { is_v2_table: true });
                if (resHistory.count > 0) {
                    // need to recover messages
                    for (let message of resHistory.items) {
                        await this.iotMessageManager.processMessage(message, true).catch(err => {
                            this.logMessagingEvent(`process message broken on: ${message.msg_id}`, err, true);
                        });
                    }
                }
                return true;
            }
        } catch (error: any) {
            if (error?.status !== -1 && error?.status !== 403 && error != "MISSING_OAUTH_DATA") {
                this.logMessagingEvent("process history", error, false);
            }

            return false;
        }
    }
    async getHistory(pagination: HistoryPagination): Promise<NotificationResult> {
        try {
            if (pagination) {
                let resHistory: NotificationResult = await this.getList("notifications", undefined, pagination);
                return resHistory;
            } else {
                let resHistory: NotificationResult = await this.getList("notifications", undefined, { is_v2_table: true });
                return resHistory;

            }
        } catch (error: any) {
            if (error?.status !== -1 && error?.status !== 403 && error != "MISSING_OAUTH_DATA") {
                this.logMessagingEvent("get History", error, false);
            }
            throw error;
        }
    }
    /**
     * @description Check if there are any missing messages in the local history
     * @returns
     */
    isMissingMessages(): MissingMessagesResult {
        const [rangeStart, rangeEnd] = [this.historyStorage.lastMessageIdChecked, this.historyStorage.lastMessageId];

        if (rangeStart >= rangeEnd - 1) {
            return {
                missing: false,
                firstElementMissing: 0
            };
        }

        const missingMessages: number[] = [];

        for (let i = rangeStart; i <= rangeEnd; i++) {
            if (!this.historyStorage.history.has(i)) {
                missingMessages.push(i);
            }
        }

        if (missingMessages.length == 0 || missingMessages.length == 1) {
            this.historyStorage.lastMessageIdChecked = rangeEnd;
        } else if (missingMessages[missingMessages.length - 1] - missingMessages[0] > 100) {
            this.historyStorage.lastMessageIdChecked = missingMessages[0] + 99;
        } else {
            this.historyStorage.lastMessageIdChecked = rangeEnd;
        }

        return {
            missing: missingMessages.length > 0,
            firstElementMissing: missingMessages[0]
        };
    }
}